<template>
  <div>
    <div style="margin-top: 20px; margin-bottom: 20px;">
      <Button
        data-testid="compromissoservico-novo-button"
        severity="primary"
        :label="t('Novo Serviço')"
        icon="pi pi-plus"
        @click="openNewModal"
        :disabled="isLoading"
      />
    </div>

    <div class="mb-3" style="margin-bottom: 20px;">
      <Button
        data-testid="compromissoservico-refresh-button"
        severity="primary"
        size="small"
        :label="t('Atualizar')"
        icon="pi pi-refresh"
        :iconClass="{'pi-spin': isLoading}"
        @click="loadData"
        :disabled="isLoading"
      />
    </div>

    <!-- CompromissoServico Table -->
    <compromisso-servico-table
      :compromisso-id="compromissoId"
      ref="compromissoServicoTableRef"
      @edit-compromisso-servico="editItem">
    </compromisso-servico-table>

    <!-- CompromissoServicoModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import CompromissoServicoTable from './CompromissoServicoTable.vue';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';

type Id = number | string;

interface TableInstance {
  loadData: () => void | Promise<void>;
}

const { t } = useI18n();

const props = withDefaults(defineProps<{
  compromissoId?: number;
  orcamentoId?: number;
}>(), {
  compromissoId: 0,
  orcamentoId: 0
});

const compromissoServicoTableRef = ref<TableInstance | null>(null);
const isLoading = ref<boolean>(false);

const loadData = async (): Promise<void> => {
  if (compromissoServicoTableRef.value) {
    await compromissoServicoTableRef.value.loadData();
  }
};

const openNewModal = (): void => {
  log('CompromissoServicoPage', 'openNewModal', 'Opening new modal via eventBus');
  eventBus.emit('modal.compromisso-servico.open', {
    action: 'new',
    compromissoId: props.compromissoId,
    orcamentoId: props.orcamentoId
  });
};

const editItem = (compromissoServicoId: Id): void => {
  log('CompromissoServicoPage', 'editItem', 'Opening modal for ID via eventBus', {
    compromissoServicoId,
    compromissoId: props.compromissoId,
    orcamentoId: props.orcamentoId
  });
  eventBus.emit('modal.compromisso-servico.open', {
    id: compromissoServicoId,
    compromissoId: props.compromissoId,
    orcamentoId: props.orcamentoId
  });
};

onMounted(() => {
});

onBeforeUnmount(() => {
});

defineExpose({
  loadData,
  openNewModal,
  editItem
});
</script>

<style scoped>
:deep(.pi-spin) {
  animation: pi-spin 2s infinite linear;
}

@keyframes pi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
</style>
